import { Link } from "react-router-dom";
import { btnPrimary } from "../components/portfolio/styles";

export default function NotFound() {
  return (
    <div
      className="max-w-4xl mx-auto py-24 text-center space-y-6"
      data-testid="not-found-page"
    >
      <h1 className="text-6xl font-bold text-foreground">404</h1>
      <p className="text-lg text-muted-foreground">The page you're looking for doesn't exist.</p>
      <Link to="/" className={btnPrimary} data-testid="back-home-btn">
        Back to Home
      </Link>
    </div>
  );
}
